<template>
    <div class="description" v-if="baseInfo != null">
        <div class="container">
            <div class="row">
                <div class="site-description col-sm-12 col-md-12 col-lg-4">
                    <header class="card-header">
                        <h3 class="site-title"> {{baseInfo.ShopName}} </h3>
                    </header>
                    <p v-html="baseInfo.AboutShortUs">
                    </p>
                </div>
              <div :class="baseInfo.EnamadLink3 != '' && baseInfo.EnamadPicPath3 != null ? 'col-12 col-lg-3 col-md-6' :'col-12 col-lg-4 col-md-6'">
                <div class="site-description">
                  <div class="row">

                    <div class="col-6 footer-link-column">
                      <header class="card-header">
                        <h3 class="site-title">دسترسی سریع</h3>
                      </header>
                      <ul class="footer-menu" style="font-size:22px;">
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/aboutUs" title="درباره ما">درباره ما</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/contactUs" title="مشاوره و تماس">مشاوره و تماس</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/rules" title="قوانین و مقررات">قوانین و مقررات</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/privacy" title="حریم خصوصی">حریم خصوصی</router-link>
                        </li>
                      </ul>
                    </div>

                    <div class="col-6 footer-link-column">
                      <header class="card-header">
                        <h3 class="site-title">محصولات</h3>
                      </header>

                      <ul class="footer-menu" style="font-size:22px;">
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/filter?GroupId=1001&GroupName=%D8%AA%D8%AC%D9%87%DB%8C%D8%B2%D8%A7%D8%AA-%D8%B1%D8%B3%D8%AA%D9%88%D8%B1%D8%A7%D9%86" title="تجهیزات رستوران">تجهیزات رستوران</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/filter?GroupId=1002&GroupName=%D8%AA%D8%AC%D9%87%DB%8C%D8%B2%D8%A7%D8%AA-%DA%A9%D8%A7%D9%81%DB%8C-%D8%B4%D8%A7%D9%BE" title="تجهیزات کافی شاپ">تجهیزات کافی شاپ</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/filter?GroupId=1004&GroupName=%D8%AA%D8%AC%D9%87%DB%8C%D8%B2%D8%A7%D8%AA-%D8%A8%D8%B1%D9%88%D8%AF%D8%AA%DB%8C" title="تجهیزات برودتی">تجهیزات برودتی</router-link>
                        </li>
                        <li>
                          <i class="fa fa-caret-left" aria-hidden="true"></i>
                          <router-link to="/filter?GroupId=1006&GroupName=%D8%AA%D8%AC%D9%87%DB%8C%D8%B2%D8%A7%D8%AA-%D9%81%D8%B3%D8%AA-%D9%81%D9%88%D8%AF" title="تجهیزات فست فود">تجهیزات فست فود</router-link>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>

              </div>
              

              <div  class="site-description  col-12 col-lg-4 col-md-6">
                  
                        <header class="card-header">
                            <h3 class="site-title">آدرس فروشگاه</h3>
                        </header>
                        <div>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d3240.2359851371575!2d51.397740288360595!3d35.695810019179014!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDQxJzQ3LjQiTiA1McKwMjMnNTEuNSJF!5e0!3m2!1sen!2s!4v1730533732813!5m2!1sen!2s" width="100%" height="300px;" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                        </div>
             
                </div>
                <a v-if="baseInfo.EnamadLink1 != '' && baseInfo.EnamadPicPath1 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink1"><img :src="baseInfo.EnamadPicPath1" :alt="baseInfo.ShopName"></a>
                <a v-if="baseInfo.EnamadLink2 != '' && baseInfo.EnamadPicPath2 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink2"><img :src="baseInfo.EnamadPicPath2" :alt="baseInfo.ShopName"></a>
                <a v-if="baseInfo.EnamadLink3 != '' && baseInfo.EnamadPicPath3 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink3"><img :src="baseInfo.EnamadPicPath3" :alt="baseInfo.ShopName"></a>
            </div>

        </div>
    </div>
    </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            redirectToPage(href) {
                window.open(href, "_blank");
            }
        }
    }
</script>

<style scoped>
    .symbol-main {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .footer-menu li {
        padding-right: 7px;
        line-height: 2.2;
    }

    .footer-link-column .card-header {
        margin-bottom: 10px;
    }

    footer.main-footer .description .site-description .site-title {
        margin-bottom: 3px;
    }

    .widget .card-header, .brand-slider .card-header {
        background-color: unset;
        border-bottom: unset;
    }

    .card-header {
        background-color: unset;
        border-bottom: 1px solid #a84646;
    }

    .footer-menu li .fa[data-v-5ef0cfb7] {
        color: #861111;
    }

    .widget {
        border-radius: unset;
        box-shadow: unset;
        background: unset;
        padding: 15px;
    }

    .footer-social a .fa {
        padding-left: 3px !important;
    }

    .footer-social a {
        padding-left: 10px;
    }

    .text-center {
        text-align: center;
    }

    .footer-menu li span.title {
        color: #888;
        font-weight: bold;
        font-size: 17px;
    }

    .footer-menu {
        padding-top: 7px;
    }

        .footer-menu li .fa {
            font-size: 18px;
            vertical-align: middle;
            padding-left: 8px;
            color: #888;
        }

        .footer-menu li a {
            color: #620505;
            font-weight: bold;
            font-size: 16px;
        }

            .footer-menu li a:hover {
                color: gray;
            }
</style>
